/**
 * Structured reasons for closing a lead as lost.
 *
 * Client-safe (no server-only imports): shared by the home Lead Inbox and the
 * lead detail sheet so both record the same reason codes. A lost lead's
 * `close_reason` is stored as `${value}` or `${value}: ${note}`; the loss
 * breakdown in lib/leads/lead-metrics.ts groups on the part before ':'.
 */
export interface LossReason {
  value: string;
  label: string;
}

export const LOSS_REASONS: readonly LossReason[] = [
  { value: 'price', label: 'Too expensive / price' },
  { value: 'chose_competitor', label: 'Chose a competitor' },
  { value: 'no_response', label: 'No response / ghosted' },
  { value: 'timing_not_now', label: 'Timing — not now' },
  { value: 'bad_fit', label: 'Not a good fit' },
  { value: 'out_of_area', label: 'Out of area' },
  { value: 'spam', label: 'Spam / not a real lead' },
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'other', label: 'Other' },
];
